import {
    AdherenceMeta,
    AdherenceScore,
    UserGoalView
} from "@curefit/gmf-common";
import { PatientPersonalProfile } from "@curefit/ups-common";
import { IMetricOptions, IMetricData, IAddMetric } from "@curefit/metrics-common";
import {
    IMedicinePrescription,
    IPatientAllergy,
    IPatientConcern,
    IPatientRedFlag,
    IPatientSurgeryAndProcedure
} from "@curefit/ehr-common";
import { IPatientDetail, ILabtestPrescription } from "@curefit/care-common";
import {isEmpty as _isEmpty} from "lodash"
import * as ActionTypes from "./ActionTypes";
import IPatientDetailAndMedicalCondition from "../models/IPatientDetailAndMedicalCondition"
import {ApiManager} from "../api/ApiManager"
import {IPatientVitalResponse} from "../models/IPatientVitalResponse"
import IPatientVital from "../models/IPatientVital"
import ICurrentMedication from "../models/ICurrentMedication";
import {IEHRSavePatientMedicalProfile} from "../models/patients/IEHRSavePatientMedicalProfile"
import IHabit from "../models/staticData/IHabit";
import IPatientCondition from "../models/IPatientCondition";
import DiagnosticReportRequestParamsBuilder from "../builder/DiagnosticReportRequestParamsBuilder";
import ILabTestMaster from "../models/ILabTestMaster";
import {ITypeFormResponse} from "../models/ITypeFormResponse";
import AppUtils from "../utils/AppUtils";
import IMealItem from "../models/IMealItem";
import LocalStorageUtils from "../utils/LocalStorageUtils";
import {ActivityDS} from "../models/IActivityStore";
import IPatientLifestylePlanWrapper from "../models/patients/IPatientLifestylePlanWrapper";
import { EHRService } from "../../../common/services/EHRService";
import { response } from "inversify-express-utils";
import {OngoingConsultationActions} from "./OngoingConsultationActions";
import * as moment from "moment";
import {SAVE_PAST_CONSULTATION_DATA} from "./ActionTypes";
import {IConfigBasedPrescription} from "../models/patients/IConfigBasedPrescription";

/**
 * Created by abhinav on 26/01/18.
 */

export class PatientCompleteInfoActions {

    /* Patient Complete Details Actions and Creators */
    static fetchPatientCompleteDetailsSuccess = (patientCompleteDetails: IPatientDetailAndMedicalCondition) => {
        return {type: ActionTypes.FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS, patientCompleteDetails : patientCompleteDetails};
    }

    static fetchPatientCompleteDetails = (dispatch: any, patientId: number) => {
        ApiManager.getAlbusApis().getPatientCompleteDetailsById(patientId).then(function(patientCompleteDetails: IPatientDetailAndMedicalCondition){
            dispatch(PatientCompleteInfoActions.fetchPatientCompleteDetailsSuccess(patientCompleteDetails));
        }).catch(error => {
            throw (error);
        });
    }

    static clearPatientCompleteDetailSuccess = (patientId: number) => {
        return {type: ActionTypes.CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS, patientId: patientId};
    }

    static clearPatientCompleteDetails = (dispatch: any, patientId: number) => {
        dispatch(PatientCompleteInfoActions.clearPatientCompleteDetailSuccess(patientId));
    }


    /* Patient Vitals Data Actions and Creators */
    static fetchPatientVitals = function (dispatch: any, patientId: number, userId: number, metricIds: number[]) {
        return ApiManager.getOrionApis().fetchUserVitalsDataFromMetricService(userId, patientId, metricIds).then(patientVitalsResponse => {
            dispatch(PatientCompleteInfoActions.fetchPatientVitalsSuccess(patientVitalsResponse.data));
        }).catch(error => {
            throw (error);
        });
        
        // return ApiManager.getAlbusApis().getPatientVitals(patientId).then(patientVitals => {
        //     dispatch(PatientCompleteInfoActions.fetchPatientVitalsSuccess(patientVitals));
        // }).catch(error => {
        //     throw (error);
        // });
    };

    static savePatientVitals = function (dispatch: any, patientId: number, patientVitals: IPatientVital[]) {
        return ApiManager.getAlbusApis().saveVitals(patientId, patientVitals).then(function(patientVitalsResp: IPatientVitalResponse[]){
            dispatch(PatientCompleteInfoActions.savePatientVitalsSuccess(patientVitalsResp));
        }).catch(error => {
            throw(error);
        });
    };

    static fetchPatientVitalsSuccess = (patientVitals: IPatientVitalResponse[]) => {
        return {type: ActionTypes.FETCH_PATIENT_VITALS_SUCCESS, patientVitals: patientVitals};
    }

    static savePatientVitalsSuccess = (patientVitals: IPatientVitalResponse[]) => {
        return {type: ActionTypes.SAVE_PATIENT_VITALS_SUCCESS, patientVitals: patientVitals};
    }

    static fetchPatientLabTestsSuccess = (patientVitals: ILabTestMaster[]) => {
        return {type: ActionTypes.FETCH_PATIENT_LAB_TESTS_SUCCESS, patientLabTests: patientVitals};
    }

    static fetchPatientPersonalInformationSuccess = (personalInfo: PatientPersonalProfile) => {
        return {type: ActionTypes.FETCH_PATIENT_PERSONAL_INFORMATION_SUCCESS, patientPersonalInfo: personalInfo};
    }

    static fetchPatientConcernsSuccess = (patientConcerns: IPatientConcern[]) => {
        return {type: ActionTypes.FETCH_PATIENT_CONCERNS_SUCCESS, patientConcerns: patientConcerns};
    }

    static fetchPatientRedFlagsSuccess = (patientRedFlags: IPatientRedFlag[]) => {
        return {type: ActionTypes.FETCH_RED_FLAGS_SUCCESS, patientRedFlags: patientRedFlags};
    }

    static fetchPatientTypeFormDataSuccess = (patientTypeFormData: ITypeFormResponse) => {
        return {type: ActionTypes.FETCH_PATIENT_TYPE_FORM_DATA_SUCCESS, patientTypeFormData: patientTypeFormData};
    }

    /* Surgery Data Actions and Creators */
    static fetchPatientSurgeryDataSuccess = (surgeryData: IPatientSurgeryAndProcedure[]) => {
        return {type: ActionTypes.FETCH_PATIENT_SURGERY_SUCCESS, surgeryData: surgeryData};
    }

    static savePatientSurgeryDataSuccess = (surgeryData: IPatientSurgeryAndProcedure[]) => {
        return {type: ActionTypes.SAVE_PATIENT_SURGERY_SUCCESS, surgeryData: surgeryData};
    }

    static fetchPatientSurgeryData = (dispatch: any, patientId: number) => {
        return ApiManager.getAlbusApis().getSurgeryAndProcedureHistoryData(patientId).then((surgeryData: IPatientSurgeryAndProcedure[]) => {
            dispatch(PatientCompleteInfoActions.fetchPatientSurgeryDataSuccess(surgeryData));
        }).catch(error => {
            throw (error);
        });
    };

    static savePatientSurgeryData = function (dispatch: any, patientId: number, surgeryData: IPatientSurgeryAndProcedure[]) {
        return ApiManager.getAlbusApis().saveSurgeryAndProcedureHistoryData(patientId, surgeryData).then((surgeryDataResp: IPatientSurgeryAndProcedure[]) => {
            dispatch(PatientCompleteInfoActions.savePatientSurgeryDataSuccess(surgeryDataResp));
        }).catch(error => {
            throw (error);
        });
    };

    /* Patient Profile Data */
    static fetchPatientProfile = (dispatch: any, patientId: number) => {
        return ApiManager.getAlbusApis().getPatientProfileById(patientId).then((patientProfiles: IPatientDetail[]) => {
            dispatch(PatientCompleteInfoActions.fetchPatientProfileSuccess(patientProfiles[0]));
        })
    }

    static fetchPatientProfileSuccess = (patientProfile: IPatientDetail) => {
        return {type: ActionTypes.FETCH_PATIENT_PROFILE_SUCCESS, patientProfile: patientProfile};
    }

    /* Patient Allergy Data */
    static fetchPatientAllergyDataSuccess = (allergies: IPatientAllergy[]) => {
        return {type: ActionTypes.FETCH_PATIENT_ALLERGY_SUCCESS, patientAllergies : allergies};
    }

    static savePatientAllergyDataSuccess = (allergies: IPatientAllergy[]) => {
        return {type: ActionTypes.SAVE_PATIENT_ALLERGY_SUCCESS, patientAllergies : allergies};
    }


    static fetchPatientAllergyData = function (dispatch: any, patientId: number) {
        return ApiManager.getAlbusApis().getAllergyData(patientId).then((allergies: IPatientAllergy[]) => {
            dispatch(PatientCompleteInfoActions.fetchPatientAllergyDataSuccess(allergies));
        }).catch(error => {
            throw (error);
        });
    };

    static savePatientAllergyData = function (dispatch: any, patientId: number, allergies: IPatientAllergy[]) {
        return ApiManager.getAlbusApis().saveAllergyData(patientId, allergies).then((allergiesResp: IPatientAllergy[]) => {
            dispatch(PatientCompleteInfoActions.savePatientAllergyDataSuccess(allergiesResp));
        }).catch(error => {
            throw (error);
        });
    };

    /* Patient Habits Data */
    static fetchPatientHabitDataSuccess = (habits: IHabit[]) => {
        return {type: ActionTypes.FETCH_PATIENT_HABIT_SUCCESS, patientHabitsList : habits};
    }

    static savePatientHabitDataSuccess = (habits: IHabit[]) => {
        return {type: ActionTypes.SAVE_PATIENT_HABIT_SUCCESS, patientHabitsList : habits};
    }

    static fetchPatientHabitData = function (dispatch: any, patientId: number) {
        return ApiManager.getAlbusApis().getHabitData(patientId).then((habits: IHabit[]) => {
            dispatch(PatientCompleteInfoActions.fetchPatientHabitDataSuccess(habits));
        }).catch(error => {
            throw (error);
        });
    };

    static savePatientHabitData = function (dispatch: any, patientId: number, habits: IHabit[]) {
        return ApiManager.getAlbusApis().saveHabitData(patientId, habits).then((habits: IHabit[]) => {
            dispatch(PatientCompleteInfoActions.savePatientHabitDataSuccess(habits));
        }).catch(error => {
            throw (error);
        });
    };

    /* Patient Current Medication Data */
    static fetchPatientCurrentMedicationDataSuccess = (meds: ICurrentMedication[]) => {
        return {type: ActionTypes.FETCH_PATIENT_CURRENT_MEDICATION_SUCCESS, currentMedication : meds};
    }

    static savePatientCurrentMedicationDataSuccess = (medicines: IMedicinePrescription[]) => {
        return {type: ActionTypes.SAVE_PATIENT_CURRENT_MEDICATION_SUCCESS, currentMedications : medicines};
    }

    static fetchPatientCurrentMedicationData = function (dispatch: any, patientId: number) {
        return ApiManager.getAlbusApis().getCurrentMedicationData(patientId).then((meds: ICurrentMedication[]) => {
            dispatch(PatientCompleteInfoActions.fetchPatientCurrentMedicationDataSuccess(meds));
        }).catch(error => {
            throw (error);
        });
    };

    static savePatientCurrentMedicationData = function (dispatch: any, patientId: number, meds: IMedicinePrescription[]) {
        return ApiManager.getAlbusApis().saveCurrentMedicationData(patientId, meds).then((medicines: IMedicinePrescription[]) => {
            dispatch(PatientCompleteInfoActions.savePatientCurrentMedicationDataSuccess(medicines));
        }).catch(error => {
            throw (error);
        });
    };


    /* Patient Comorbid conditions data */
    static fetchPatientComorbidConditionDataSuccess = (conditions: IPatientCondition[]) => {
        return {type: ActionTypes.FETCH_PATIENT_COMORBID_CONDITIONS_SUCCESS, comorbidConditions: conditions};
    }

    static savePatientComorbidConditionDataSuccess = (conditions: IPatientCondition[]) => {
        return {type: ActionTypes.SAVE_PATIENT_COMORBID_CONDITIONS_SUCCESS, comorbidConditions : conditions};
    }

    static fetchPatientComorbidConditionData = function (dispatch: any, patientId: number) {
        return ApiManager.getAlbusApis().getComorbidConditionData(patientId).then((conditions: IPatientCondition[]) => {
            dispatch(PatientCompleteInfoActions.fetchPatientComorbidConditionDataSuccess(conditions));
        }).catch(error => {
            throw (error);
        });
    };

    static savePatientComorbidConditionData = function (dispatch: any, patientId: number, patientConditions: IPatientCondition[]) {
        return ApiManager.getAlbusApis().saveComorbidConditionData(patientId, patientConditions).then((conditions: IPatientCondition[]) => {
            dispatch(PatientCompleteInfoActions.savePatientComorbidConditionDataSuccess(conditions));
        }).catch(error => {
            throw (error);
        });
    };

    /* Patient All Medicine Data */
    static fetchPatientMedicalProfileSuccess = function (patientMedicalProfile: IEHRSavePatientMedicalProfile) {
        return {type: ActionTypes.FETCH_PATIENT_MEDICAL_PROFILE_SUCCESS, patientMedicalProfile : patientMedicalProfile};
    }

    static savePatientMedicalProfileSuccess = function (patientId: number, patientMedicalProfile: IEHRSavePatientMedicalProfile) {
        return {type: ActionTypes.SAVE_PATIENT_MEDICAL_PROFILE_SUCCESS, patientMedicalProfile : patientMedicalProfile};
    }

    static fetchPatientMedicalProfile = function(dispatch: any, patientId: number) {
        return ApiManager.getAlbusApis().getPatientMedicalProfile(patientId).then((patientMedicalProfile: IEHRSavePatientMedicalProfile) => {
            dispatch(PatientCompleteInfoActions.fetchPatientMedicalProfileSuccess(patientMedicalProfile));
        }).catch(error => {
            throw (error);
        });
    }

    static fetchPatientPastSessions =  function(dispatch:any, patientId: number, subSectionKey: string ) {
        return ApiManager.getAlbusApis().getPatientPastSession(patientId, subSectionKey).then((responseData: any) =>{
            let noOfSessions = responseData.length;
            responseData = responseData.map((data: any) => {
                return { ...data, sessionNo: `${noOfSessions--}  (past)`, date: moment(data.createdAt).format("DD MMMM, YYYY") };
            });
            dispatch(PatientCompleteInfoActions.fetchPatientPastSessionsSuccess(responseData));
        })
    }
    static fetchPatientPastSessionsSuccess = function (responseData: any) {
        return {type: ActionTypes.FETCH_PATIENT_PAST_SESSIONS_SUCCESS , responseData };
    }

    static savePatientMedicalProfile = function(dispatch: any, patientId: number, patientMedicalProfile: IConfigBasedPrescription, appointmentId: number, doctorType: string){
        return ApiManager.getEHRApis().savePatientMedicalProfile(patientId, patientMedicalProfile, appointmentId, doctorType).then((response: IEHRSavePatientMedicalProfile) => {
                dispatch(OngoingConsultationActions.updateConfigMedicalProfile(response));
        });
    }

    static savePatientDiagnosticLabTests = (dispatch: any, dataObject: ILabtestPrescription[]) => {
        return ApiManager.getMetricServiceApis().savePatientDiagnosticLabTests(dataObject).then((response: ILabtestPrescription[]) => {
            // dispatch(PatientCompleteInfoActions.savePatientLabTestsSuccess(response));
            dispatch(OngoingConsultationActions.savePatientDiagnosticLabTests(response));
            dispatch(OngoingConsultationActions.updateManualLabTests([]))
        });
    }

    static deletePatientDiagnosticLabTests = async function(dispatch: any, deletedLabTestIds: number[]) {
        const response = await ApiManager.getOrionApis().deletePatientDiagnosticLabTests(deletedLabTestIds);
    }

    static savePatientLabTestsSuccess = function (dataObject: any) {
        return {type: ActionTypes.SAVE_PATIENT_LAB_TESTS_SUCCESS, patientLabTests: dataObject };
    }

    static savePatientLabTests = function(patientLabTests: any) {
        return {type: ActionTypes.SAVE_PATIENT_LAB_TESTS, patientLabTests}
    }

    /* PATIENT LAB TESTS */
    static fetchPatientLabTests = function (dispatch: any, patientId: number) {
        let reqBuilder: DiagnosticReportRequestParamsBuilder = new DiagnosticReportRequestParamsBuilder();
        reqBuilder.setPatientId(patientId).setCompletedOrder(true).setWithReports(true).setReportGenOrder(false);
        return ApiManager.getAlbusApis().getPatientLabTests(patientId, reqBuilder.build()).then(patientLabTests => {
            dispatch(PatientCompleteInfoActions.fetchPatientLabTestsSuccess(patientLabTests));
        }).catch(error => {
            throw (error);
        });
    };

    // static savePatientLabTests = function(dispatch: any, dataObject: any) {
    //     return ApiManager.getMetricServiceApis().saveUserMetric(dataObject).then( response => {
    //         dispatch(this.savePatientLabTestsSuccess(response));
    //     });
    // }


    /* Patient Prescription Save */
    // static savePatientPrescription = function(dispatch: any, patientId: number, patientPrescription: IPrescription){
    //     return ApiManager.getAlbusApis().savePatientMedicalProfile(patientId, patientPrescription).then(function(){
    //         dispatch(PatientCompleteInfoActions.savePatientPrescriptionSuccess(patientId, patientPrescription));
    //     }).catch(error => {
    //         throw (error);
    //     })
    // }

    /* PATIENT PERSONAL INFORMATION */
    static fetchPatientPersonalInformation = (dispatch: any, curefitId: number, patientId: number, isSelf: boolean) => {
        return ApiManager.getPolarisApis().getPatientPersonalProfile(curefitId, patientId, isSelf).then(personalProfile => {
            dispatch(PatientCompleteInfoActions.fetchPatientPersonalInformationSuccess(personalProfile));
        }).catch(error => {
            dispatch(PatientCompleteInfoActions.fetchPatientPersonalInformationSuccess({} as PatientPersonalProfile));
            // throw (error);
        });
    }

    static savePatientPersonalInformation = (dispatch: any, curefitId: string, patientId: number, isSelf: boolean, profile: PatientPersonalProfile) => {
        return ApiManager.getPolarisApis().saveAllProfilesForPatient(curefitId, patientId, isSelf, profile).then(personalInformation => {
            dispatch(PatientCompleteInfoActions.fetchPatientPersonalInformationSuccess(profile));
        }).catch(error => {
            throw (error);
        });
    }

    /* PATIENT CONCERNS */
    static savePatientConcerns = (dispatch: any, patientId: number, medicalProfile: IEHRSavePatientMedicalProfile, appointmentId: number, doctorType: string ) => {
        return ApiManager.getEHRApis().savePatientMedicalProfile(patientId, medicalProfile, appointmentId, doctorType).then(medProfile => {
            dispatch(PatientCompleteInfoActions.fetchPatientConcernsSuccess(medicalProfile.concerns));
        }).catch(error => {
            throw (error);
        });
    }

    /* PATIENT RED FLAGS */
    static savePatientRedFlags = (dispatch: any, patientId: number, medicalProfile: IEHRSavePatientMedicalProfile, appointmentId: number, doctorType: string) => {
        return ApiManager.getEHRApis().savePatientMedicalProfile(patientId, medicalProfile, appointmentId, doctorType).then(medProfile => {
            dispatch(PatientCompleteInfoActions.fetchPatientRedFlagsSuccess(medicalProfile.redFlags));
        }).catch(error => {
            throw (error);
        });
    }

    /* PATIENT TYPEFORM DATA */
    static fetchPatientTypeFormData = (dispatch: any, patientId: number) => {
        return ApiManager.getAlbusApis().fetchPatientTypeFormData(patientId).then(typeFormData => {
            dispatch(PatientCompleteInfoActions.fetchPatientTypeFormDataSuccess(typeFormData));
        }).catch(error => {
            dispatch(PatientCompleteInfoActions.fetchPatientTypeFormDataSuccess({patientAssessment: null, userForm: null}));
            // throw (error);
        });
    }

    static savePatientAdherenceDetails = (data: AdherenceMeta[]) => {
        return { type: ActionTypes.SAVE_PATIENT_ADHERENCE_DATA, payload: data }
    };

    static fetchMealDetails = (mealIds: string[]) => {
        const unsavedMeals = mealIds.filter((item: string) => _isEmpty(LocalStorageUtils.getMealFromMealId(item)));
        console.log("UNSAVED MEALS", unsavedMeals);
        if (!_isEmpty(unsavedMeals)) {
            ApiManager.getRamsayApis().getMealsByMealIds(unsavedMeals).then((response: IMealItem[]) => {
                LocalStorageUtils.createAdherenceMealsMap(response);
            })
        }
    };

    static saveDSActivityMap = (data: {[key: string]: ActivityDS}) => {
        return { type: ActionTypes.SAVE_ADHERENCE_ACTIVITY_DATA, payload: data }
    };

    static fetchPatientAdherenceDetails = (dispatch: any, userId: number, startEpoch: number, endEpoch: number) => {
        let reqParams = {
            userId,
            startEpoch,
            endEpoch
        };
        ApiManager.getOrionApis().getPatientAdherenceDetails(reqParams).then((response) => {
            console.log("DATA IS COMING", response);
            let mealIds = AppUtils.getAllMealIds(response);
            const activityIds = AppUtils.getAllLoggedActivityIds(response);
            console.log("ACTIVITY IDS", activityIds);
            if (mealIds.length > 0) {
                PatientCompleteInfoActions.fetchMealDetails(mealIds)
            }
            dispatch(PatientCompleteInfoActions.savePatientAdherenceDetails(response))
        }).catch((err) => {
            console.log("SOME ERROR CAME", err);
        })
    };

    static getPatientPlanForView = (dispatch: any, secondaryUserId: string) => {
        return ApiManager.getOrionApis().getPatientLifestylePlanView(secondaryUserId).then(response => {
            const patientPlan = AppUtils.isDefined(response) && !_isEmpty(response.data) && !_isEmpty(response.data.newConfigData) ? response.data.newConfigData : null;
            // const patientGoals = AppUtils.isDefined(response) && !_isEmpty(response.patientGoals) ? response.patientGoals : null;
            dispatch(PatientCompleteInfoActions.savePatientPlanView(patientPlan));
            // dispatch(PatientCompleteInfoActions.savePatientGoalsView(patientGoals));
        })
    }

    static savePatientPlanView = (plan: IPatientLifestylePlanWrapper) => {
        return {type: ActionTypes.SAVE_PATIENT_PLAN_VIEW, payload: plan}
    };

    static savePatientGoalsView = (goals: UserGoalView[]) => {
        return {type: ActionTypes.SAVE_PATIENT_GOALS_VIEW, payload: goals}
    };

    static getPatientMetrics = (dispatch: any, req: IMetricOptions) => {
        ApiManager.getMetricServiceApis().fetchUserMetric(req).then(response => {
            dispatch(PatientCompleteInfoActions.saveFetchedPatientMetrics(response, req.metricId));
        });
    }

    static saveFetchedPatientMetrics = (data: IMetricData[], metricId: number) => {
        return {
            type: ActionTypes.SAVE_PATIENT_METRICS_DATA,
            payload: {data, metricId}
        }
    };

    static savePatientsOverallScores = (data: {[key: string]: {[key: string]: AdherenceScore[]}}) => {
        return {
            type: ActionTypes.SAVE_PATIENTS_OVERALL_ADHERENCE_SCORES,
            payload: data
        }
    };

    static getPatientsOverallScores = (dispatch: any, aggregateLevel: string, startEpoch: number, endEpoch: number, userIds: string) => {
        return ApiManager.getOrionApis().getPatientsOverallAdherenceScores(aggregateLevel, startEpoch, endEpoch, userIds).then(response => {
            console.log("RESPONSE", response)
            dispatch(PatientCompleteInfoActions.savePatientsOverallScores(response || {}))
        }).catch((err: any) => {
            console.log("ERROR", err)
        })
    };

    static searchPatients = (curefitUserId: string): Promise<any> => {
        return ApiManager.getAlbusApis().searchPatients(curefitUserId);
    };

    static searchDoctorPatients = (doctorId: any, query: any) : Promise<any> => {
       return ApiManager.getAlbusApis().searchDoctorPatients(doctorId, query);
    }

    static savePastConsultationData = (payload: any) => {
        return {type: SAVE_PAST_CONSULTATION_DATA, payload}
    }

    static fetchPastConsultationData = (dispatch: any, consultationId: string, doctorType: string, patientId: string): Promise<any> => {
        return ApiManager.getOrionApis().fetchPastConsultationDataForPatient(consultationId, doctorType, patientId).then((data: any) => {
            dispatch(PatientCompleteInfoActions.savePastConsultationData({consultationId, data}))
        })
    }

}
